<template>
    <div class="card mb-3">
        <div class="row no-gutters">
            <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-7 align-self-center">
                            <div v-if="reportDescription != ''" class="card">
                                <div class="card-body">
                                    <div class="card-text">
                                        {{ reportDescription }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4">
                            <base-input alternative="" label="From"><br>
                                <a-range-picker v-model="inputDate" :showTime="{ format: 'hh:mm' }" format="MM/DD/YYYY hh:mm A" :placeholder="['Start Time', 'End Time']" style="width:100%"/>
                            </base-input>
                        </div>
                        <div class="col-md-4">
                            <base-input label="Group By" >
                                <select v-if="inputType == 4" class="form-control" v-model="inputGroupBy" disabled>
                                    <option v-for="option in groupOptions" v-bind:value="option.key" v-bind:key="option.key">
                                        {{ option.value }}
                                    </option>
                                </select>

                                <select v-else class="form-control" v-model="inputGroupBy">
                                    <option v-for="option in groupOptions" v-bind:value="option.key" v-bind:key="option.key">
                                        {{ option.value }}
                                    </option>
                                </select>
                            </base-input>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <base-input alternative="" label="Select Site">
                                <a-select mode="multiple" v-model="inputSite" showSearch placeholder="All Sites" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :disabled="site_type != 'ho'">
                                    <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                </a-select>
                            </base-input>
                        </div>

                        <div class="col-md-4">
                            <base-input label="Type" >
                                <select class="form-control" v-model="inputType">
                                    <option v-for="option in typeOptions" v-bind:value="option.key" v-bind:key="option.key">
                                        {{ option.value }}
                                    </option>
                                </select>
                            </base-input>
                        </div>
                    </div>

                    <base-checkbox class="mb-3" v-model="isComputeVat">
                        Compute VAT as net of VAT discount
                    </base-checkbox>

                    <base-checkbox class="mb-3" v-model="isExtendedFormat">
                        Use Extended Format (NON-VAT/VAT-EX)
                    </base-checkbox>
                    
                    <button type="button" class="btn btn-primary float-right" @click.prevent="generateReport">Generate</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import moment from 'moment';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable';
    import { getReportDescription } from '../../utilities';

    import {
        mapState
    } from 'vuex'

    export default {
        data() {
            return {
                inputDate: [moment().startOf('day'), moment().endOf('day')],
                inputSite: [],
                site_type: "ho",
                siteOptions: [],
                inputGroupBy: 'terminal_id',
                groupOptions: [
                    {key: 'terminal_id', value: 'Terminal'},
                    {key: 'user_id', value: 'Cashier'}
                ],
                inputType: 1,
                typeOptions: [
                    {key: 1, value: 'VAT Sales (Net Sales)'},
                    {key: 2, value: 'VAT Sales Report'},
                    {key: 3, value: 'VAT Returns Report'},
                    {key: 4, value: 'VAT Net Sales Per Day (Running Bal.)'}
                ],
                isComputeVat: true,
                isExtendedFormat: false,
                birSalesReports: [],
                reportDescription: ''
            }
        },
        computed: {
            ...mapState(['endPoint']),
        },
        mounted: async function () {
            var component_x = this;

            var userId = secureStorage.getItem("userId")
            var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
            component_x.siteOptions = sites;
            component_x.sort(component_x.siteOptions);

            let siteId = secureStorage.getItem("defaultSiteId")
            this.inputSite = [siteId]
            this.reportDescription = await getReportDescription(this.currentProfile)

            let site = await HTTPRequest.getRequest(component_x.endPoint + "/sites/" + siteId, null)
            if(site != undefined){
                component_x.site_type = site.site_type
            }
        },
        methods: {
            moment,
            filterOption(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            sort(data){
                data.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });
            },
            convertToCurrency(num){
                return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },
            openNotificationWithIcon(type, msg) {
                this.$notification[type]({
                    message: 'Export Error',
                    description: msg 
                });
            },
            generateReport: async function () {
                let byGroup = ''
                if(this.inputType != '4'){
                    byGroup = this.inputGroupBy
                }

                if(this.inputDate.length == 0){
                    this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                    return
                }

                var get_request = await HTTPRequest.getRequest(this.endPoint + 'pos_documents/pos_vat_sales_summary?site_id=' + this.inputSite + 
                    '&date_from=' + this.inputDate[0].format('YYYY-MM-DD HH:ss:mm') + '&date_to=' + 
                    this.inputDate[1].format('YYYY-MM-DD HH:ss:mm') + '&group=' + byGroup + '&type=' + this.inputType + '&is_compute_vat=' + 
                    this.isComputeVat + '&is_extended_format=' + this.isExtendedFormat, null)
                if(get_request.error) {
                    this.openNotificationWithIcon('error', get_request.error);
                    return
                }
                var siteSpecific = get_request;
                if(siteSpecific.length > 0){
                    var doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'legal'});

                    let reportLogo = document.getElementById('reportLogo');
                    doc.addImage(reportLogo, "PNG", 15, 0, 15, 15);

                    let header_detail = []

                    if(this.inputType == 4){
                        header_detail.push({content: 'Day', styles: {halign: 'center'}})
                    } else {
                        header_detail.push({content: 'Terminal', styles: {halign: 'center'}})
                    }
                    
                    header_detail.push({content: 'VAT Sales', styles: {halign: 'center'}})

                    if(this.isExtendedFormat == true){
                        header_detail.push({content: 'NON VAT', styles: {halign: 'center'}})
                    }

                    header_detail.push({content: 'VAT Exempt\nSales', styles: {halign: 'center'}})
                    if(this.inputType == 4){
                        header_detail.push({content: 'Total Sales\nLess VAT Ex', styles: {halign: 'center'}})
                    }

                    header_detail.push({content: 'Zero Rated\nSales', styles: {halign: 'center'}})
                    header_detail.push({content: 'Total Sales', styles: {halign: 'center'}})
                    header_detail.push({content: 'VAT', styles: {halign: 'center'}})
                    header_detail.push({content: 'VAT Exempt/\nZero Rated', styles: {halign: 'center'}})
                    header_detail.push({content: 'VAT Payable', styles: {halign: 'center'}})
                    header_detail.push({content: 'SC VAT Exempt', styles: {halign: 'center'}})

                    var headers = [header_detail];

                    for(var x=0; x < siteSpecific.length; x++){
                        this.birSalesReports = siteSpecific[x].report_details

                        if(x > 0 && this.birSalesReports.length > 0){
                            doc.addPage();
                        }

                        if(this.birSalesReports.length > 0){
                            let grandtotal_vat_sales = 0
                            let grandtotal_vat_exempt_sales = 0
                            let grandtotal_zero_rate_sales = 0
                            let grandtotal_total_sales = 0
                            let grandtotal_vat = 0
                            let grandtotal_vat_exempt_zero_rated = 0
                            let grandtotal_vat_payable = 0
                            let grandtotal_sc_vat_exempt = 0
                            let grandtotal_non_vat = 0

                            let subtotal_vat_sales = 0
                            let subtotal_vat_exempt_sales = 0
                            let subtotal_zero_rate_sales = 0
                            let subtotal_total_sales = 0
                            let subtotal_vat = 0
                            let subtotal_vat_exempt_zero_rated = 0
                            let subtotal_vat_payable = 0
                            let subtotal_sc_vat_exempt = 0
                            let subtotal_non_vat = 0

                            let reportData = [];
                            let grouper = ''

                            for(var i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]
                                if(this.inputGroupBy == 'user_id'){
                                    if(grouper == ''){
                                        let detail1 = ['Cashier :', reportLine.cashier_name];
                                        reportData.push(Object.assign({}, detail1))
                                    } else {
                                        if(grouper != reportLine.user_id){
                                            let detail1 = ['Cashier :', reportLine.cashier_name];
                                            reportData.push(Object.assign({}, detail1))
                                        }
                                    }
                                    grouper = reportLine.user_id
                                } else if(this.inputType == 4){
                                    let date_header = moment(reportLine.business_date).format('MMMM YYYY')

                                    if(grouper == ''){
                                        let detail1 = [date_header];
                                        reportData.push(Object.assign({}, detail1))
                                    } else {
                                        if(grouper != date_header){
                                            let detail1 = [date_header];
                                            reportData.push(Object.assign({}, detail1))
                                        }
                                    }
                                    grouper = date_header
                                }

                                
                                if(this.isExtendedFormat == true){
                                    grandtotal_non_vat += Number(reportLine.non_vat)
                                    subtotal_non_vat += Number(reportLine.non_vat)
                                }

                                grandtotal_vat_sales += Number(reportLine.vat_sales)
                                grandtotal_vat_exempt_sales += Number(reportLine.vat_exempt_sales)
                                grandtotal_zero_rate_sales += Number(reportLine.zero_rate_sales)
                                grandtotal_total_sales += Number(reportLine.total_sales)
                                grandtotal_vat += Number(reportLine.vat)
                                grandtotal_vat_exempt_zero_rated += Number(reportLine.vat_exempt_zero_rated)
                                grandtotal_vat_payable += Number(reportLine.vat_payable)
                                grandtotal_sc_vat_exempt += Number(reportLine.sc_vat_exempt)

                                subtotal_vat_sales += Number(reportLine.vat_sales)
                                subtotal_vat_exempt_sales += Number(reportLine.vat_exempt_sales)
                                subtotal_zero_rate_sales += Number(reportLine.zero_rate_sales)
                                subtotal_total_sales += Number(reportLine.total_sales)
                                subtotal_vat += Number(reportLine.vat)
                                subtotal_vat_exempt_zero_rated += Number(reportLine.vat_exempt_zero_rated)
                                subtotal_vat_payable += Number(reportLine.vat_payable)
                                subtotal_sc_vat_exempt += Number(reportLine.sc_vat_exempt)

                                let detail = []

                                detail = []
                                if(this.inputType == 4){
                                    detail.push(moment(reportLine.business_date).format('MM/DD/YYYY'))
                                    detail.push(this.convertToCurrency(grandtotal_vat_sales))
                                    
                                    if(this.isExtendedFormat == true){
                                        detail.push(this.convertToCurrency(grandtotal_non_vat))
                                    }

                                    detail.push(this.convertToCurrency(grandtotal_vat_exempt_sales))

                                    let sales_less_vatex = grandtotal_vat_sales - grandtotal_vat_exempt_sales
                                    detail.push(this.convertToCurrency(sales_less_vatex))
                                    detail.push(this.convertToCurrency(grandtotal_zero_rate_sales))
                                    detail.push(this.convertToCurrency(grandtotal_total_sales))
                                    detail.push(this.convertToCurrency(grandtotal_vat))
                                    detail.push(this.convertToCurrency(grandtotal_vat_exempt_zero_rated))
                                    detail.push(this.convertToCurrency(grandtotal_vat_payable))
                                    detail.push(this.convertToCurrency(grandtotal_sc_vat_exempt))

                                    reportData.push(Object.assign({}, detail))
                                } else {
                                    detail.push(reportLine.terminal_name)
                                    detail.push(this.convertToCurrency(Number(reportLine.vat_sales)))

                                    if(this.isExtendedFormat == true){
                                        detail.push(this.convertToCurrency(Number(reportLine.non_vat)))
                                    }
                                    
                                    detail.push(this.convertToCurrency(Number(reportLine.vat_exempt_sales)))
                                    detail.push(this.convertToCurrency(Number(reportLine.zero_rate_sales)))
                                    detail.push(this.convertToCurrency(Number(reportLine.total_sales)))
                                    detail.push(this.convertToCurrency(Number(reportLine.vat)))
                                    detail.push(this.convertToCurrency(Number(reportLine.vat_exempt_zero_rated)))
                                    detail.push(this.convertToCurrency(Number(reportLine.vat_payable)))
                                    detail.push(this.convertToCurrency(Number(reportLine.sc_vat_exempt)))

                                    reportData.push(Object.assign({}, detail))

                                    if(i == this.birSalesReports.length - 1){
                                        if(this.inputGroupBy == 'user_id'){
                                            let sub_detail = ["Total :",
                                                this.convertToCurrency(subtotal_vat_sales),    
                                            ]

                                            if (this.isExtendedFormat == true){
                                                sub_detail.push(this.convertToCurrency(subtotal_non_vat))
                                            }

                                            sub_detail.push(this.convertToCurrency(subtotal_vat_exempt_sales))
                                            sub_detail.push(this.convertToCurrency(subtotal_zero_rate_sales))
                                            sub_detail.push(this.convertToCurrency(subtotal_total_sales))
                                            sub_detail.push(this.convertToCurrency(subtotal_vat))
                                            sub_detail.push(this.convertToCurrency(subtotal_vat_exempt_zero_rated))
                                            sub_detail.push(this.convertToCurrency(subtotal_vat_payable))
                                            sub_detail.push(this.convertToCurrency(subtotal_sc_vat_exempt))

                                            reportData.push(Object.assign({}, ["rowLine"]))
                                            reportData.push(Object.assign({}, sub_detail))    
                                        }

                                        let grand_detail = ["Grand Total :",
                                            this.convertToCurrency(grandtotal_vat_sales),    
                                        ]

                                        if (this.isExtendedFormat == true){
                                            grand_detail.push(this.convertToCurrency(grandtotal_non_vat))
                                        }

                                        grand_detail.push(this.convertToCurrency(grandtotal_vat_exempt_sales))
                                        grand_detail.push(this.convertToCurrency(grandtotal_zero_rate_sales))
                                        grand_detail.push(this.convertToCurrency(grandtotal_total_sales))
                                        grand_detail.push(this.convertToCurrency(grandtotal_vat))
                                        grand_detail.push(this.convertToCurrency(grandtotal_vat_exempt_zero_rated))
                                        grand_detail.push(this.convertToCurrency(grandtotal_vat_payable))
                                        grand_detail.push(this.convertToCurrency(grandtotal_sc_vat_exempt))

                                        reportData.push(Object.assign({}, ["rowLine"]))
                                        reportData.push(Object.assign({}, grand_detail))
                                    } else {
                                        let next_grouper = ""
                                        if(this.inputGroupBy == 'user_id'){
                                            next_grouper = this.birSalesReports[i+1].user_id
                                            if(grouper != next_grouper){
                                                let sub_detail = ["Total :",
                                                    this.convertToCurrency(subtotal_vat_sales),    
                                                ]

                                                if (this.isExtendedFormat == true){
                                                    sub_detail.push(this.convertToCurrency(subtotal_non_vat))
                                                }

                                                sub_detail.push(this.convertToCurrency(subtotal_vat_exempt_sales))
                                                sub_detail.push(this.convertToCurrency(subtotal_zero_rate_sales))
                                                sub_detail.push(this.convertToCurrency(subtotal_total_sales))
                                                sub_detail.push(this.convertToCurrency(subtotal_vat))
                                                sub_detail.push(this.convertToCurrency(subtotal_vat_exempt_zero_rated))
                                                sub_detail.push(this.convertToCurrency(subtotal_vat_payable))
                                                sub_detail.push(this.convertToCurrency(subtotal_sc_vat_exempt))

                                                reportData.push(Object.assign({}, ["rowLine"]))
                                                reportData.push(Object.assign({}, sub_detail))  
                                                
                                                subtotal_vat_sales = 0
                                                subtotal_vat_exempt_sales = 0
                                                subtotal_zero_rate_sales = 0
                                                subtotal_total_sales = 0
                                                subtotal_vat = 0
                                                subtotal_vat_exempt_zero_rated = 0
                                                subtotal_vat_payable = 0
                                                subtotal_sc_vat_exempt = 0
                                                subtotal_non_vat = 0
                                            }
                                        }
                                    }
                                }
                            }

                            let group_text = ""
                            if(this.inputGroupBy == 'terminal_id'){
                                group_text = ' by Terminal'
                            } else if(this.inputGroupBy == 'customer_id'){
                                group_text = ' by Customer'
                            }

                            let type_text = ""
                            if(this.inputType == 1){
                                type_text = 'Sales Summary [Net Sales]';
                            } else if(this.inputType == 2){
                                type_text = 'Sales Summary';
                            } else if(this.inputType == 3){
                                type_text = 'Returns Summary';
                            } else if(this.inputType == 4){
                                group_text = ''
                                type_text = 'Net Sales Per Day [Running Balance]';
                            }

                            doc.setFontSize(14);
                            doc.setFontType("bold");

                            doc.text(15,20,'POS Vat ' + type_text + group_text)
                            doc.setFontType("normal");
                            doc.setFontSize(10);
                            
                            doc.text(340,20,siteSpecific[x].report_details[0].site_name, "right")
                            doc.text(15,25,"For the Period of " + this.inputDate[0].format('MMMM DD, YYYY hh:mm A')  + " to " + this.inputDate[1].format('MMMM DD, YYYY hh:mm A'))

                            let colStyle = {}
                            if(this.isExtendedFormat == true && this.inputType == 4){
                                colStyle =  {
                                    0: {cellWidth: 30},
                                    1: {cellWidth: 30},
                                    2: {cellWidth: 30},
                                    3: {cellWidth: 30},
                                    4: {cellWidth: 30},
                                    5: {cellWidth: 30},
                                    6: {cellWidth: 30},
                                    7: {cellWidth: 30},
                                    8: {cellWidth: 30},
                                    9: {cellWidth: 30},
                                    10: {cellWidth: 30}
                                }
                            } else if(this.isExtendedFormat == true || this.inputType == 4){
                                colStyle =  {
                                    0: {cellWidth: 45},
                                    1: {cellWidth: 35},
                                    2: {cellWidth: 30},
                                    3: {cellWidth: 30},
                                    4: {cellWidth: 30},
                                    5: {cellWidth: 35},
                                    6: {cellWidth: 30},
                                    7: {cellWidth: 30},
                                    8: {cellWidth: 30},
                                    9: {cellWidth: 30}
                                }
                            } else {
                                colStyle =  {
                                    0: {cellWidth: 45},
                                    1: {cellWidth: 35},
                                    2: {cellWidth: 35},
                                    3: {cellWidth: 35},
                                    4: {cellWidth: 35},
                                    5: {cellWidth: 35},
                                    6: {cellWidth: 35},
                                    7: {cellWidth: 35},
                                    8: {cellWidth: 35}
                                }
                            }

                            doc.autoTable({
                                startY: 30, 
                                head: headers, 
                                body: reportData, 
                                theme: 'plain',
                                tableWidth: 'wrap',
                                headStyles: {
                                    lineWidth: 0.15,
                                    cellPadding: 2
                                },
                                styles: {
                                    cellPadding: 1.0, fontSize: 9,
                                    halign: 'right'
                                },
                                columnStyles: colStyle,
                                didParseCell: function(data) {
                                    if (data.row.section == 'body' && data.row.raw[0] == 'rowLine'){
                                        data.cell.styles.fillColor = [0, 0, 0]
                                        data.cell.styles.fontSize = 1
                                        data.cell.styles.cellPadding = 0
                                    } else if (data.row.section == 'body' && (data.row.raw[0] == 'Total :' && data.row.raw[0] == 'Grand Total :')){
                                        data.cell.styles.fontStyle = 'bold'
                                    }
                                }
                            });

                            doc.text(15,205,"Printed By: " + secureStorage.getItem("email"))
                            doc.text(340,205,"POS Vat Sales Summary" + group_text, "right")
                            doc.text(15,210,"Print Date: " + moment().format("MM/DD/YYYY h:mm:ssA"))
                            doc.text(340,210,"Page " + ( x + 1)  + " of " + siteSpecific.length, "right")
                        }
                    }

                    //doc.save(`POS_Vat_Exempt_Sales_${moment().format(this.dateFormat)}.pdf`); 
                    window.open(URL.createObjectURL(doc.output("blob")))
                } else {
                    this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                }
            }
        }
    };
</script>

<style></style>